module.exports = __webpack_public_path__ + "static/media/logo.531ef719.png";